import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { Checkbox, createMultiStyleConfigHelpers } from "@chakra-ui/react";
import React from "react";
import { CheckboxIcon } from "shared/components/input/checkbox/Checkbox";
import { textStyles } from "theme/textStyles";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  checkboxAnatomy.keys,
);

const CheckboxTheme = defineMultiStyleConfig({
  baseStyle: {
    control: {
      bg: "white",
      borderRadius: 4,
      borderWidth: 1,
      borderColor: "gray.300",
      color: "primary.600",
      _checked: {
        backgroundColor: "primary.50",
        borderColor: "primary.600",
        color: "primary.600",
        _hover: {
          "&:not([data-disabled])": {
            backgroundColor: "primary.50",
          },
        },
        _disabled: {
          backgroundColor: "primary.50",
          borderColor: "primary.600",
          color: "primary.600",
        },
      },
      _indeterminate: {
        backgroundColor: "primary.50",
        borderColor: "primary.600",
        color: "primary.600",
        _hover: {
          "&:not([data-disabled])": {
            backgroundColor: "primary.50",
          },
        },
        _disabled: {
          opacity: 0.5,
          backgroundColor: "primary.50",
          borderColor: "primary.600",
          color: "primary.600",
        },
      },
      _hover: {
        "&:not([data-disabled])": {
          backgroundColor: "primary.50",
          borderColor: "primary.600",
        },
      },
      _disabled: {
        opacity: 0.5,
        backgroundColor: "white",
        borderColor: "gray.300",
      },
      _invalid: {
        color: "error.600",
        backgroundColor: "unset",
        borderColor: "error.300",
        _disabled: {
          backgroundColor: "unset",
        },
        _hover: {
          "&:not([data-disabled])": {
            borderColor: "unset",
            backgroundColor: "error.50",
          },
        },
        _checked: {
          color: "error.600",
          borderColor: "unset",
          backgroundColor: "error.50",
        },
        _indeterminate: {
          color: "error.600",
          borderColor: "unset",
          backgroundColor: "error.50",
        },
      },
      _focusVisible: {
        boxShadow: "none",
        outlineStyle: "solid",
        outlineColor: "#F4EBFF",
        outlineWidth: "4px",
      },
    },
    label: {
      _invalid: {
        color: "error.600",
      },
    },
  },
  sizes: {
    md: {
      label: {
        fontSize: textStyles.body.fontSize,
      },
    },
  },
});

Checkbox.defaultProps = {
  icon: React.createElement(CheckboxIcon),
};

export default CheckboxTheme;
